import { useCallback } from 'react';
import { debounce } from 'lodash';

export const useDebounce = (callback: Function, delay: number) =>
  useCallback(
    debounce((...args) => callback(...args), delay),
    [delay]
  );
